module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "discovery"
    }
  }), _vm._v(" "), _c('swiper', {
    ref: "swiper1",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "600px"
    },
    attrs: {
      "src": require("../../assets/images/gzheader.png")
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "600px"
    },
    attrs: {
      "src": require("../../assets/images/czheader.png")
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "600px"
    },
    attrs: {
      "src": require("../../assets/images/cz1.png")
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "600px"
    },
    attrs: {
      "src": require("../../assets/images/gzheader.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "d_content"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "cr_list"
  }, _vm._l((_vm.classes), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ClassDetail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.img_url),
        expression: "item.img_url"
      }]
    }), _vm._v(" "), _c('div', {
      staticClass: "class_info"
    }, [_c('p', {
      staticClass: "class_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "class_date"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('p', {
      staticClass: "class_content"
    }, [_vm._v(_vm._s(item.desc))])])])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "d_navigation"
  }, [_c('span', {
    staticClass: "nav_title"
  }, [_vm._v("听英语")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    class: {
      cur: _vm.audio.listen
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.slideTo(0)
      }
    }
  }, [_vm._v("听力")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      cur: _vm.audio.music
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.slideTo(1)
      }
    }
  }, [_vm._v("音乐")])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "listen_container"
  }, [_c('a', {
    staticClass: "arrow_left",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.leftSwiper
    }
  }), _vm._v(" "), _c('swiper', {
    ref: "swiper2",
    staticClass: "swiper-container listen_list",
    attrs: {
      "options": _vm.swiperOption2
    }
  }, [_c('swiper-slide', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "slide"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/discovery/music.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("高一听力")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/discovery/music.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("初一听力")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/discovery/music.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("高二听力")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/discovery/music.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("高三听力")])])])]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "slide"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/discovery/listen.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("Deaf Havan")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/discovery/listen.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("Deaf Havan")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/discovery/listen.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("Deaf Havan")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/discovery/listen.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("Deaf Havan")])])])])], 1), _vm._v(" "), _c('a', {
    staticClass: "arrow_right",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.rightSwiper
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "article_list"
  }, _vm._l((_vm.articles), function(item) {
    return _c('li', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy:background-image",
        value: (item.img_url),
        expression: "item.img_url",
        arg: "background-image"
      }],
      key: item.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ArticleDetail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "vidio_thumb"
    }, [_c('p', {
      staticClass: "thumb_title articl_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.date))])])])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d_navigation"
  }, [_c('span', {
    staticClass: "nav_title"
  }, [_vm._v("维学课堂")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("查看更多")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("查看更多")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d_navigation"
  }, [_c('span', {
    staticClass: "nav_title"
  }, [_vm._v("推荐文章")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("查看更多")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8405cd50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Discovery/Index.vue
// module id = 98
// module chunks = 0